import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import HomeSeekingSection from '../../../organisms/HomeEditorial/HomeSeekingSection';
import {
  BAND_SEEKING_ALLOWED_TYPES,
  BAND_SEEKING_FIELD,
  getActiveBandSeekingDetails,
  normalizeBandSeekingDraft,
  serializeBandSeekingMembersPayload,
} from '../../../../utils/bandSeeking';

export default function BandSeekingSection({
  id = 'seeking',
  seekingMembers = {},
  instrumentsNeeded = {},
  editing = false,
  onFieldSave,
}) {
  const { t } = useTranslation();
  const rawSeeking = useMemo(() => normalizeBandSeekingDraft({
    seekingMembers,
    instrumentsNeeded,
  }), [instrumentsNeeded, seekingMembers]);
  const seekingDetails = useMemo(() => getActiveBandSeekingDetails({
    seekingMembers,
    instrumentsNeeded,
  }), [instrumentsNeeded, seekingMembers]);

  return (
    <HomeSeekingSection
      id={id}
      eyebrow={t('bandPage.seeking.eyebrow', { defaultValue: 'Seeking' })}
      title={seekingDetails
        ? t('bandPage.seeking.titleMembers', { defaultValue: 'Looking for members.' })
        : t('bandPage.seeking.titleNone', { defaultValue: 'Not looking right now.' })}
      side={t('bandPage.seeking.side', {
        defaultValue: 'Visible on the public band page when the band is looking for members.',
      })}
      lookingForLabel={t('bandPage.seeking.lookingFor', { defaultValue: 'Looking for' })}
      membersLabel={t('bandPage.seeking.lookingForMembers', { defaultValue: 'Members' })}
      noneLabel={t('bandPage.seeking.lookingForNone', { defaultValue: 'Not looking' })}
      orLabel={t('bandPage.seeking.or', { defaultValue: 'or' })}
      seekingType={seekingDetails?.type}
      openToJam={false}
      openToJamEnabled={false}
      bandStyles={[]}
      members={seekingDetails?.members || []}
      membersChipLabel={t('bandPage.seeking.lookingForRoles', { defaultValue: 'Looking for' })}
      membersEditorLabel={t('bandPage.seeking.membersEditorLabel', { defaultValue: 'Roles you need' })}
      notesPlaceholder={t('bandPage.seeking.notesPlaceholder', {
        defaultValue: 'Tell musicians what roles you need and what joining this band looks like.',
      })}
      quote={seekingDetails?.notes || ''}
      genres={[]}
      emptyTitle={t('bandPage.seeking.emptyTitle', { defaultValue: 'No member search yet' })}
      emptyDescription={t('bandPage.seeking.emptyDescription', {
        defaultValue: 'When this band starts looking for members, the roles will appear here.',
      })}
      editing={editing}
      rawSeeking={rawSeeking}
      allowedSeekingTypes={BAND_SEEKING_ALLOWED_TYPES}
      allowPlainTextFallback={false}
      fieldName={BAND_SEEKING_FIELD}
      serializeDraft={serializeBandSeekingMembersPayload}
      onFieldSave={onFieldSave}
    />
  );
}

BandSeekingSection.propTypes = {
  id: PropTypes.string,
  seekingMembers: PropTypes.object,
  instrumentsNeeded: PropTypes.object,
  editing: PropTypes.bool,
  onFieldSave: PropTypes.func,
};
